<template>
  <div>
    <v-container fluid grid-list-xl ref="phasesForm">
      <template v-if="can('edit', 'tournament', tournament)">
        <v-layout wrap>
          <v-flex xs12 ml-3>
            <span
              class="title"
            >{{localPhase._id ? getName(localPhase.name) : $t('newAModel', {field: $tc('phase')})}}</span>
          </v-flex>

          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-flex d-flex lg12 md12 sm12 xs12>
              <v-tabs color="primary" fixed-tabs ref="tablanguage">
                <v-tab
                  :key="index + 100"
                  v-for="(lang, index) in localPhase.name"
                >{{lang.language.name}}</v-tab>
                <v-tab-item :key="index + 200" v-for="(lang, index) in localPhase.name">
                  <v-container fluid grid-list-xl>
                    <v-layout wrap>
                      <v-flex d-flex lg12 md12 sm12 xs12>
                        <IgTextField
                          :disabled="!Edit"
                          :rules="valid ? [] : [v => !lang.language.required || rules.vacio(v, 'name')]"
                          :status="true"
                          :label="$t('name')"
                          :ref="lang.language.required ? 'focus' : ''"
                          v-model="lang.text"
                        ></IgTextField>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex d-flex xs12>
            <v-flex d-flex md2 xs12>
              <v-switch
                v-model="localPhase.showResults"
                :label="$t('ifShowResults')"
                color="primary"
              ></v-switch>
            </v-flex>
            <v-flex d-flex md2 xs12 v-if="!localPhase._id && type == 'teams'">
              <v-switch
                v-model="localPhase.randomMatches"
                :label="$t('ifRandomMatches')"
                color="primary"
              ></v-switch>
            </v-flex>

            <v-flex d-flex md4 xs12>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="hour"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="hour"
                    :label="$t('time')"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu"
                  v-model="hour"
                  full-width
                  @click:minute="$refs.menu.save(hour)"
                ></v-time-picker>
              </v-menu>
              <v-btn small color="success" v-if="hour" @click="addHour()">
                {{$t('addField', {field:
                $t('time')})}}
              </v-btn>
              <!-- <div>
                <div v-for="(hour, index) in localPhase.hours" v-bind:key="1100 + index">
                  <v-chip close @input="removeHour(index)">{{hour}}</v-chip>
                </div>
              </div>-->
            </v-flex>
            <v-flex  md4 xs12>
              <v-chip
                v-for="(hour, index) in localPhase.hours"
                v-bind:key="1100 + index"
                close
                @input="removeHour(index)"
              >{{hour}}</v-chip>
            </v-flex>
          </v-flex>
          <v-flex d-flex xs12>
            <v-layout wrap>
              <v-flex md3 xs12>
                <v-radio-group
                  :rules="valid ? [] : [v => rules.vacio(v, 'typePlayOff')]"
                  ref="typePlayOff"
                  :label="$t('typePlayOff')"
                  v-model="localPhase.typePlayOff"
                >
                  <v-radio color="primary" :label="$t('ranking')" value="ranking"></v-radio>
                  <v-radio
                    v-if="type === 'teams'"
                    color="primary"
                    :label="$t('winners')"
                    value="winners"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <template v-if="localPhase.typePlayOff === 'ranking'">
                <v-flex d-flex md2 xs12>
                  <v-text-field
                    type="number"
                    :label="$t('toClass')"
                    id="toClass"
                    min="1"
                    :max="toClass"
                    step="1"
                    maxlength="2"
                    :rules="valid ? [] : [v => rules.minNumber(v, 1),v => rules.maxNumber(v,'toClass' ,toClass )]"
                    v-model.number="localPhase.toClass"
                  ></v-text-field>
                </v-flex>
                <v-flex d-flex md2 xs12>
                  <v-text-field
                    type="number"
                    :label="$t('matchesByParticipant')"
                    id="matchesByParticipant"
                    min="1"
                    max="10"
                    step="1"
                    maxlength="2"
                    :rules="valid ? [] : [v => rules.minNumber(v, 1)]"
                    v-model.number="localPhase.matchesByParticipant"
                  ></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-xs-right>
            <v-btn
              @click="()=>{localPhase = templatePhase(), valid = true}"
              small
              color="warning"
            >{{$t('reset')}}</v-btn>
            <v-btn @click="setPhase()" small :color="localPhase._id ? 'secondary' : 'success'">
              <span v-if="loading">
                <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
              </span>
              <span
                v-else
              >{{ localPhase._id ? $t('updateModel', {field: $tc('phase')}) : $t('addField', {field: $tc('phase')})}}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <v-layout wrap>
        <div class="v-table__overflow">
          <table class="text-xs-center v-datatable v-table theme--light" style="width:100%;">
            <thead>
              <tr>
                <th>{{$t('actions')}}</th>
                <th>{{$t('order')}}</th>
                <th>{{$t('name')}}</th>
                <th>{{$t('ifShowResults')}}</th>
                <th>{{$t('ifRandomMatches')}}</th>
                <th>{{$t('typePlayOff')}}</th>
                <th>{{$t('toClass')}}</th>
                <th>{{$t('matchesByParticipant')}}</th>
                <th>{{$t('hours')}}</th>
              </tr>
            </thead>
            <!-- <tbody> -->
            <draggable
              v-model="localPhases"
              tag="tbody"
              :handle="isMobile ? '.handle': '' "
              @end="dragEnd"
              :class="localPhases.length > 1 ? 'draggable': ''"
            >
              <tr v-for="(phase, index) in localPhases" :key="index + 20">
                <td class="handle">
                  <template v-if="can('edit', 'tournament', tournament)">
                    <v-btn v-if="localPhase._id != phase._id" flat icon color="success">
                      <v-icon class="icon material-icons" @click="edit(phase)">edit</v-icon>
                    </v-btn>
                    <v-btn v-else flat icon color="secondary">
                      <v-icon class="icon material-icons" @click="setPhase()">save</v-icon>
                    </v-btn>
                    <v-btn flat icon color="error">
                      <v-icon
                        class="icon material-icons"
                        @click="() => {idPhase = phase._id; phaseName = phase.name; dialog = true;}"
                      >delete</v-icon>
                    </v-btn>
                  </template>
                </td>

                <td class="py-2">{{phase.order}}</td>
                <td>{{getName(phase.name)}}</td>
                <td>
                  <i
                    v-if="phase.showResults"
                    class="success--text icon material-icons subheading"
                  >check_circle</i>
                  <i v-else class="error--text icon material-icons subheading">cancel</i>
                </td>
                <td>
                  <i
                    v-if="phase.randomMatches"
                    class="success--text icon material-icons subheading"
                  >check_circle</i>
                  <i v-else class="error--text icon material-icons subheading">cancel</i>
                </td>
                <td>{{$t(phase.typePlayOff)}}</td>
                <td>{{phase.typePlayOff === 'ranking' ? phase.toClass : '-'}}</td>
                <td>{{phase.typePlayOff === 'ranking' ? phase.matchesByParticipant : '-'}}</td>
                <td>{{phase.hours.join(', ')}}</td>

                <hr />
              </tr>
            </draggable>

            <!-- </tbody> -->
          </table>
        </div>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
        <v-card-text v-html="$t('confirmADelete', {field: $tc('phase'), name: getName(phaseName)})"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color flat="flat" @click="dialog = false">{{$t('cancel')}}</v-btn>

          <v-btn color="error" flat="flat" @click="deletePhase()">
            <span v-if="loadingDelete">
              <v-progress-circular :size="20" :width="3" color="red" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('delete')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import rules from '../../../helpers/rules'
import queueToast from '../../../helpers/queueToast'
import draggable from 'vuedraggable'
import { close } from 'fs'

export default {
  name: 'tabPhases',
  mixins: [rules],
  components: {
    draggable
  },
  props: {
    Edit: {
      type: Boolean,
      required: true
    },
    phases: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localPhase: {},
      localPhases: [],
      hour: '',
      idPhase: '',
      phaseName: [],
      loading: false,
      loadingDelete: false,
      menu: false,
      dialog: false,
      valid: true
    }
  },
  mounted() {
    this.resetLocal()
  },
  watch: {
    tournament(val) {
      if (val._id) this.resetLocal()
    },
    'localPhase.typePlayOff': function(newVal, oldVal) {
      if (newVal != 'ranking') {
        this.localPhase.matchesByParticipant = 1
        this.localPhase.toClass = Math.floor(this.toClass / 2)
      }
    }
  },
  computed: {
    ...mapState({
      tournamentId: state => state.tournaments.idSelected,
      tournament: state => state.tournaments.selected
    }),
    toClass() {
      if (this.tournament) return this.tournament.numberParticipants
      else return 1
    }
  },
  methods: {
    ...mapActions({
      setCreateNew: 'phases/setCreateNew',
      setUpdate: 'phases/setUpdate',
      setDelete: 'phases/setDelete',
      setUpdateTournament: 'tournaments/setUpdate'
    }),
    templatePhase() {
      return {
        order: 0,
        name: this.setComplexLanguage(),
        hours: [],
        typePlayOff: '',
        toClass: Math.floor(this.toClass / 2),
        matchesByParticipant: 1,
        showResults: false,
        randomMatches: false
      }
    },
    addHour() {
      if (!this.localPhase.hours.includes(this.hour))
        this.localPhase.hours.push(this.hour)
      this.hour = null
    },
    edit(phase) {
      this.localPhase = { ...phase }
      this.$refs.phasesForm.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    isValidPhase() {
      const defaultLangId = this.$store.state.languages.defaultLangId
      const {
        name,
        typePlayOff,
        toClass,
        matchesByParticipant
      } = this.localPhase
      let error = false
      let messages = []
      const spanishLang = name.find(lang => lang.langId === defaultLangId)
      if (!spanishLang || !spanishLang.text) {
        error = true
        messages.push(this.$t('error.nameSpanish'))
      }

      if (!typePlayOff) {
        error = true
        messages.push(
          this.$t('error.required', { field: this.$t('typePlayOff') })
        )
      } else if (typePlayOff === 'ranking') {
        if (!toClass || toClass <= 0) {
          error = true
          messages.push(
            this.$t('error.required', { field: this.$t('toClass') })
          )
        }
        if (toClass && toClass > this.toClass) {
          error = true
          messages.push(
            this.$t('error.maxNumber', {
              field: this.$t('toClass'),
              max: this.toClass
            })
          )
        }
        if (!matchesByParticipant || matchesByParticipant <= 0) {
          error = true
          messages.push(
            this.$t('error.required', {
              field: this.$t('matchesByParticipant')
            })
          )
        }
      }
      if (error) {
        queueToast(messages)
        this.valid = false
        return false
      }
      return true
    },
    setPhase() {
      if (this.loading || !this.isValidPhase()) return

      let phase = { ...this.localPhase }
      phase.name = this.getComplexLanguage(phase.name)

      if (phase.groups) delete phase.groups
      if (phase.typePlayOff != 'ranking') {
        delete phase.toClass
        delete phase.matchesByParticipant
      }
      let payload = {
        idTournament: this.tournament._id,
        phase
      }
      this.loading = true
      if (phase._id) {
        this.setUpdate(payload).finally(() => (this.loading = false))
      } else {
        if (this.phases.length) {
          const maxOrder = this.phases.reduce((prev, curr) =>
            prev.order > curr.order ? prev : curr
          ).order
          payload.phase.order = maxOrder + 1
        } else payload.phase.order = 1
        this.setCreateNew(payload).finally(() => (this.loading = false))
      }
    },
    deletePhase() {
      if (this.loadingDelete) return

      const payload = {
        idTournament: this.tournament._id,
        idPhase: this.idPhase
      }

      this.loadingDelete = true
      this.setDelete(payload).finally(() => {
        this.loadingDelete = false
        this.dialog = false
      })
    },
    dragEnd() {
      if (!this.can('edit', 'tournament', this.tournament)) return
      const listPhases = this.localPhases.map((phase, index) => {
        let result = {
          ...phase,
          order: index + 1
        }
        return result
      })

      let tournament = {
        _id: this.tournament._id,
        phases: listPhases
      }
      this.loading = true
      this.setUpdateTournament(tournament).finally(() => (this.loading = false))
    },
    removeHour(index) {
      this.localPhase.hours.splice(index, 1)
    },
    resetLocal() {
      this.valid = true
      this.loading = false

      this.localPhase = Object.assign({}, this.templatePhase())

      this.hour = ''
      this.localPhases = this.phases.map(phase => {
        return {
          ...phase,
          name: this.setComplexLanguage(phase.name)
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>
